import { render, staticRenderFns } from "./CustomMetadataLabelSelector.vue?vue&type=template&id=575bce5f&lang=pug"
import script from "./CustomMetadataLabelSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomMetadataLabelSelector.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports